(function() {
    'use strict';

    angular
        .module('quantixApp')
        .factory('AuthTrackerProvider', AuthTrackerProvider);

    AuthTrackerProvider.$inject = ['$http', '$localStorage', '$sessionStorage', '$window','AuthKeycloak'];

    function AuthTrackerProvider ($http, $localStorage, $sessionStorage, $window,AuthKeycloak) {
        var service = {
            getToken: getToken,
            logout: logout,
            checkDuplicateLogins:checkDuplicateLogins,
            continueWithCurrentSession :continueWithCurrentSession,
            cancelCurrentSession :cancelCurrentSession,
            dummyMethodCalling :dummyMethodCalling
        };

        return service;

        function getToken () {
            return $localStorage.authenticationToken || $sessionStorage.authenticationToken;
        }

        function logout () {
          
            delete $localStorage.authenticationToken;
            delete $sessionStorage.authenticationToken;
            delete $sessionStorage.sessionConfrimation;
            $window.localStorage.clear();
           
            AuthKeycloak.authz.logout({'redirectUri':AuthKeycloak.logoutUrl});
            
        }
        
        
        function checkDuplicateLogins(){
        	
        	return $http.post('api/trackerLoginEntry',{ignoreLoadingBar: true});
        	
        }
        
        function continueWithCurrentSession(){
        	
        	return $http.post('api/continueWithCurrentSession',{ignoreLoadingBar: true});
        	
        }
        
        function cancelCurrentSession(){
        	
        	return $http.post('api/cancelCurrentSession',{ignoreLoadingBar: true});
        	
        }
        
        function dummyMethodCalling(){
        	
        	return $http.post('api/dummyMethodCalling',{ignoreLoadingBar: true});
        	
        }
        
        
        
        
        
    }
})();